// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright-module--copyright--1ariN","copyright__dot":"Copyright-module--copyright__dot--2-Kyr"};